<template>
	<div class="BuildCodingTest-main-container" style="overflow: hidden">
		<div
			style="position: fixed; top: 20px; z-index: 1; backdrop-filter: blur(2px)"
			v-if="LoaderStatus"
		>
			<Spinner />
		</div>
		<div class="d-flex align-items-center position-relative">
			<div class="d-flex">
				<img
					src="../../assets/icons/Reports/bckarrow.svg"
					alt=""
					class="pointer"
					@click="goBack()"
				/>
			</div>
			<div class="bct-yellow-position">
				<img src="../../assets/yellowOval.svg" alt="" />
			</div>
			<div class="bct-main-head ml-3" style="z-index: 2">Edit Question</div>
		</div>
		<template v-if="openPreview">
			<div>
				<div class="bct-preview-container d-flex mb-1 mt-3">
					<div class="bct-preview-left" style="width: 55%">
						<div class="d-flex align-items-center justify-content-between">
							<div class="bct-preview-head">Question</div>
							<div
								@click="goToDocumentUpload()"
								class="addtype-text ans-text mr-3"
							>
								Try Question
							</div>
						</div>
						<div
							class="bct-card-subtext mt-3 mb-4 ml-2"
							style="width: 86%; margin: 12px 0px 25px 9px"
						>
							You are given a sorted array consisting of only integers where
							every element appears exactly twice, except for one element which
							appears exactly once.Return the single element that appears only
							once. You are given a sorted array consisting of only integers
							where every element appears exactly twice, except for one element
							which appears exactly once.Return the single element that appears
							only once.
						</div>
						<div class="bct-TC-card p-3 m-2">
							<span class="bct-preview-head">Constrain</span>
							<div class="mt-3">
								<ul>
									<li v-for="i in loopVar2" :key="i" class="bct-card-subtext">
										1 = nums.length = 105 = 45 - 58943 > 598495 == 48958388
										should be always true here should be always true here.
									</li>
								</ul>
							</div>
						</div>
						<div class="bct-TC-card p-3 m-2">
							<span class="bct-preview-head">Sample</span>
							<div class="p-3 bct-card-subtext d-flex flex-column">
								<span> Input: nums = [1,1,2,3,3,4,4,8,8] </span>
								<span> Output: 2 </span>
							</div>
						</div>
						<div class="bct-TC-card p-3 m-2">
							<span class="bct-preview-head">Test Cases</span>
							<div class="d-flex">
								<div class="bct-many-testCase-left" style="width: 25%">
									<!--********************   SELECTED TEST CASE CLASS  *********************-->
									<div class="p-2 bct-many-testCase-sel-text">
										Test Case Selected
									</div>
									<!--********************   UNSELECTED TEST CASE  CLASS *********************-->
									<div
										class="p-2 bct-many-testCase-text"
										v-for="i in loopVar"
										:key="i"
									>
										Test Case {{ i }}
									</div>
								</div>
								<div class="bct-many-testCase-right" style="width: 75%">
									<div class="bct-TC-card p-3 m-2">
										<span class="bct-preview-head">Input</span>
										<div class="bct-card-subtext ml-3 mt-2">
											nums = [1,1,2,3,3,4,4,8,8]
										</div>
									</div>
									<div class="bct-TC-card p-3 m-2">
										<span class="bct-preview-head">Output</span>
										<div class="bct-card-subtext ml-3 mt-2">nums = 2</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="bct-preview-line-box" style="width: 1%"></div>
					<div style="width: 44%">
						<div class="bct-code-body-preview ml-3 p-3">
							Lorem ipsum dolor sit amet consectetur, adipisicing elit. Nesciunt
							maiores consequuntur voluptas impedit vel at in ratione enim.
							Commodi, qui. Ad id eos exercitationem corrupti saepe ab placeat,
							inventore voluptate atque, molestiae labore harum doloribus
							commodi. Iusto deserunt dicta omnis suscipit harum officia sunt,
							optio odit enim architecto! Sunt voluptates veritatis officiis
							dolorum nisi aperiam qui soluta doloribus necessitatibus quo,
							quas, similique deserunt consequatur veniam quod ut impedit unde
							at. Nulla itaque, accusantium, cumque neque alias, magnam debitis
							deleniti id vel cupiditate officiis! Sunt cupiditate illo eos
							suscipit doloremque magnam eligendi laboriosam perferendis, a
							minus rem, molestias recusandae ipsa optio! Eaque beatae numquam
							dolorem ut quaerat obcaecati quas nisi repudiandae illum, ipsum
							molestias rem eos odio. Sint saepe vel, neque, consequatur,
							tempore alias voluptates impedit laboriosam provident illum sit
							vero obcaecati voluptatibus temporibus aut optio suscipit! Impedit
							nisi, exercitationem obcaecati magnam atque, soluta voluptatum quo
							consectetur sit ullam eaque officiis saepe repudiandae quia
							voluptates odio dolorum sunt qui. Eius, molestiae nisi. Sint
							possimus minima, soluta suscipit dolorem id hic dolore laudantium
							earum consequuntur deleniti qui enim itaque reiciendis? Error
							maxime incidunt, voluptatem similique, at recusandae rerum
							voluptatum et minus quos natus ratione facere quam nulla fugiat
							Lorem ipsum dolor sit amet consectetur adipisicing elit.
							Laudantium nulla, iusto nam saepe molestiae optio quidem quisquam
							placeat fugiat corporis aut fuga vel mollitia ipsam neque
							aspernatur fugit! Hic, est, consequatur aliquam quam optio neque
							blanditiis deserunt impedit ab rem, sint veniam ad praesentium
							corporis nam nemo unde alias sequi. enim quae. Quisquam, sunt.
						</div>
					</div>
				</div>
				<div
					class="bct-bottom-button d-flex align-items-center justify-content-end"
				>
					<div class="bct-cancel-btn-parent">
						<b-button class="bct-cancel-btn mr-4">Back to Question</b-button>
					</div>
					<b-button class="bct-save-btn">Save & Next</b-button>
				</div>
			</div>
		</template>
		<template v-else>
			<div
				class="bct-button-container mt-3 d-flex justify-content-center position-relative"
			>
				<div style="border: 1px dashed #ffc145; width: 95%"></div>

				<!--*******************    question button    ********************-->

				<div
					@click="openQuestionFunc()"
					v-if="openQuestion && !questionInvalid"
					class="bct-blue-btn bct-ques"
				>
					<img class="mr-2" src="../../assets/blueQues.svg" alt="" />
					Question
				</div>
				<div
					v-else-if="!openQuestion && !questionInvalid"
					@click="openQuestionFunc()"
					class="bct-grey-btn bct-ques pointer"
				>
					<img class="mr-2" src="../../assets/greyQues.svg" alt="" />
					Question
				</div>

				<div
					@click="openQuestionFunc()"
					v-if="openQuestion && questionInvalid"
					class="bct-blue-btn bct-ques"
				>
					<img class="mr-2" src="../../assets/questioninvalid.svg" alt="" />
					Question
				</div>
				<div
					v-else-if="!openQuestion && questionInvalid"
					@click="openQuestionFunc()"
					class="bct-grey-btn bct-ques pointer"
				>
					<img class="mr-2" src="../../assets/questioninvalid.svg" alt="" />
					Question
				</div>
				<!--*******************    Blue test case button    ********************-->

				<div
					@click="openTestCaseFunc()"
					v-if="openTestCase && !testInvalid"
					class="bct-blue-btn bct-testCase"
				>
					<img src="../../assets/blueTestCase.svg" alt="" />
					Test Cases
				</div>
				<div
					v-else-if="!openTestCase && !testInvalid"
					@click="openTestCaseFunc()"
					class="bct-grey-btn bct-testCase pointer"
				>
					<img src="../../assets/greyTestCase.svg" alt="" />
					Test Cases
				</div>
				<div
					@click="openTestCaseFunc()"
					v-if="openTestCase && testInvalid"
					class="bct-blue-btn bct-testCase"
				>
					<img src="../../assets/testcaseinvalid.svg" alt="" />
					Test Cases
				</div>
				<div
					v-else-if="!openTestCase && testInvalid"
					@click="openTestCaseFunc()"
					class="bct-grey-btn bct-testCase pointer"
				>
					<img src="../../assets/testcaseinvalid.svg" alt="" />
					Test Cases
				</div>
				<!--*******************    code snip button    ********************-->

				<div
					v-if="openCode && !codesnippetInvalid"
					@click="openCodeFunc()"
					class="bct-blue-btn bct-codeSnip"
				>
					<img src="../../assets/blueCodeSnip.svg" alt="" />
					Code Snippet
				</div>
				<div
					v-else-if="!openCode && !codesnippetInvalid"
					@click="openCodeFunc()"
					class="bct-grey-btn bct-codeSnip pointer"
				>
					<img src="../../assets/greyCodeSnip.svg" alt="" />
					Code Snippet
				</div>
				<div
					v-else-if="!openCode && codesnippetInvalid"
					@click="openCodeFunc()"
					class="bct-grey-btn bct-codeSnip pointer"
				>
					<img src="../../assets/codeSnippetinvalid.svg" alt="" />
					Code Snippet
				</div>
				<div
					v-else-if="openCode && codesnippetInvalid"
					@click="openCodeFunc()"
					class="bct-blue-btn bct-codeSnip"
				>
					<img src="../../assets/codesnippetinvalidfill.svg" alt="" />
					Code Snippet
				</div>
			</div>
			<div v-if="openQuestion" class="bct-main-content mb-1 mt-2">
				<div style="width: 48%" class="mt-2 relativeclass">
					<label class="bct-content-heading">Title </label>
					<b-form-input
						class="bct-inputfield defaultCursor relativeclass"
						placeholder="Enter Title"
						type="text"
						ref="TitleInput"
						v-model="$v.question.title.$model"
						:class="{
							error: $v.question.title.$error || !$v.question.title.maxLength,
						}"
					>
					</b-form-input>
					<div
						style="position: absolute; top: 38px; right: 15px"
						v-if="$v.question.title.$dirty && !$v.question.title.required"
						v-b-popover.hover.top.v-danger="{ content: 'Required' }"
						variant="primary"
					>
						<img src="../../assets/deletepopupicon.svg" alt="" />
					</div>
					<div
						style="position: absolute; top: 37px; right: 6px"
						v-if="!$v.question.title.maxLength && $v.question.title.required"
						v-b-popover.hover.top.v-danger="{
							content: 'Should not exceed 120 characters',
						}"
						variant="primary"
					>
						<img src="../../assets/deletepopupicon.svg" alt="" />
					</div>
				</div>
				<div style="width: 100%" class="mt-2 bct-ck1">
					<span class="bct-content-heading"> Question </span>

					<div
						class="relativeclass mt-2"
						:class="
							dirtyCheckQuestion ||
							(!$v.question.question.maxLength && !dirtyCheckQuestion)
								? 'error'
								: ''
						"
					>
						<QuillEditor
							:addquesProp="addques1"
							:value="$v.question.question.$model"
							@validationVal="validateText"
							@questionText="updateQuestionContent"
							@addquesBack="changedaddQues"
						>
						</QuillEditor>
						<div
							style="position: absolute; top: 6px; right: 15px"
							v-if="dirtyCheckQuestion && $v.question.question.required"
							v-b-popover.hover.top.v-danger="{ content: 'Required' }"
							variant="primary"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
						<div
							style="position: absolute; top: 6px; right: 15px"
							v-if="!$v.question.question.maxLength && !dirtyCheckQuestion"
							v-b-popover.hover.top.v-danger="{
								content: 'Should not exceed 10000 characters',
							}"
							variant="primary"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>

						<div
							style="position: absolute; top: 6px; right: 15px"
							v-if="dirtyCheckQuestion && !$v.question.question.required"
							v-b-popover.hover.top.v-danger="{ content: 'Required' }"
							variant="primary"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
					</div>
				</div>
				<div class="d-flex">
					<div style="width: 50%" class="mt-2 bct-ck2 mr-4">
						<span class="bct-content-heading"> Sample Input </span>

						<div
							class="relativeclass mt-2"
							:class="
								dirtyCheckSampleInput ||
								(!$v.question.sampleInput.maxLength && !dirtyCheckSampleInput)
									? 'error'
									: ''
							"
						>
							<QuillEditor
								:addquesProp="addques2"
								:value="$v.question.sampleInput.$model"
								@validationVal="validateText2"
								@questionText="updateQuestionContent2"
								@addquesBack="changedaddQues2"
							>
							</QuillEditor>
							<div
								style="position: absolute; top: 6px; right: 15px"
								v-if="dirtyCheckSampleInput && $v.question.sampleInput.required"
								v-b-popover.hover.top.v-danger="{ content: 'Required' }"
								variant="primary"
							>
								<img src="../../assets/deletepopupicon.svg" alt="" />
							</div>
							<div
								style="position: absolute; top: 6px; right: 15px"
								v-if="
									!$v.question.sampleInput.maxLength && !dirtyCheckSampleInput
								"
								v-b-popover.hover.top.v-danger="{
									content: 'Should not exceed 1024 characters',
								}"
								variant="primary"
							>
								<img src="../../assets/deletepopupicon.svg" alt="" />
							</div>
							<div
								style="position: absolute; top: 6px; right: 15px"
								v-if="
									dirtyCheckSampleInput && !$v.question.sampleInput.required
								"
								v-b-popover.hover.top.v-danger="{ content: 'Required' }"
								variant="primary"
							>
								<img src="../../assets/deletepopupicon.svg" alt="" />
							</div>
						</div>
					</div>
					<div style="width: 50%" class="mt-2 bct-ck2">
						<span class="bct-content-heading"> Sample Output </span>

						<div
							class="relativeclass mt-2"
							:class="
								dirtyCheckSampleOutput ||
								(!$v.question.sampleOutput.maxLength && !dirtyCheckSampleOutput)
									? 'error'
									: ''
							"
						>
							<QuillEditor
								:addquesProp="addques3"
								:value="$v.question.sampleOutput.$model"
								@validationVal="validateText3"
								@questionText="updateQuestionContent3"
								@addquesBack="changedaddQues3"
							>
							</QuillEditor>

							<div
								style="position: absolute; top: 6px; right: 15px"
								v-if="
									dirtyCheckSampleOutput && $v.question.sampleOutput.required
								"
								v-b-popover.hover.top.v-danger="{ content: 'Required' }"
								variant="primary"
							>
								<img src="../../assets/deletepopupicon.svg" alt="" />
							</div>
							<div
								style="position: absolute; top: 6px; right: 15px"
								v-if="
									!$v.question.sampleOutput.maxLength && !dirtyCheckSampleOutput
								"
								v-b-popover.hover.top.v-danger="{
									content: 'Should not exceed 1024 characters',
								}"
								variant="primary"
							>
								<img src="../../assets/deletepopupicon.svg" alt="" />
							</div>

							<div
								style="position: absolute; top: 6px; right: 15px"
								v-if="
									dirtyCheckSampleOutput && !$v.question.sampleOutput.required
								"
								v-b-popover.hover.top.v-danger="{ content: 'Required' }"
								variant="primary"
							>
								<img src="../../assets/deletepopupicon.svg" alt="" />
							</div>
						</div>
					</div>
				</div>
				<div class="d-flex">
					<div style="width: 50%" class="bct-ck3 mt-2 mr-4">
						<span class="bct-content-heading"> Constraints </span>

						<div
							class="relativeclass mt-2"
							:class="
								dirtyCheckConstraints ||
								(!$v.question.constraints.maxLength && !dirtyCheckConstraints)
									? 'error'
									: ''
							"
						>
							<QuillEditor
								:addquesProp="addques4"
								:value="$v.question.constraints.$model"
								@validationVal="validateText4"
								@questionText="updateQuestionContent4"
								@addquesBack="changedaddQues4"
							>
							</QuillEditor>
							<div
								style="position: absolute; top: 6px; right: 15px"
								v-if="dirtyCheckConstraints && $v.question.constraints.required"
								v-b-popover.hover.top.v-danger="{ content: 'Required' }"
								variant="primary"
							>
								<img src="../../assets/deletepopupicon.svg" alt="" />
							</div>
							<div
								style="position: absolute; top: 6px; right: 15px"
								v-if="
									!$v.question.constraints.maxLength && !dirtyCheckConstraints
								"
								v-b-popover.hover.top.v-danger="{
									content: 'Should not exceed 1024 characters',
								}"
								variant="primary"
							>
								<img src="../../assets/deletepopupicon.svg" alt="" />
							</div>
							<div
								style="position: absolute; top: 6px; right: 15px"
								v-if="
									dirtyCheckConstraints && !$v.question.constraints.required
								"
								v-b-popover.hover.top.v-danger="{ content: 'Required' }"
								variant="primary"
							>
								<img src="../../assets/deletepopupicon.svg" alt="" />
							</div>
						</div>
					</div>

					<div style="width: 50%" class="d-flex mt-2">
						<div style="width: 50%" class="mr-3 relativeclass">
							<div class="position-relative">
								<label class="bct-content-heading">Category </label>
								<div
									ref="qbdropcat1"
									@click="bctDrp1 = !bctDrp1"
									class="bct-select d-flex justify-content-between relativeclass"
									:class="{
										error: $v.question.category.$error,
									}"
								>
									<span class="text-truncate">{{
										question.category == ""
											? "Select Category"
											: question.category
									}}</span>
									<span v-if="!bctDrp1"
										><img src="../../assets/carrotdown.svg" alt="" class="mr-1"
									/></span>
									<span v-else
										><img src="../../assets/uparrow.svg" alt="" class="mr-1"
									/></span>
									<div
										style="position: absolute; top: 8px; right: 28px"
										v-if="
											$v.question.category.$dirty &&
											!$v.question.category.required
										"
										v-b-popover.hover.top.v-danger="{ content: 'Required' }"
										variant="primary"
									>
										<img src="../../assets/deletepopupicon.svg" alt="" />
									</div>
								</div>
								<div
									v-if="bctDrp1"
									class="bct-checkboxcontainer pointer"
									ref="qbdropcat"
									v-closable="{
										exclude: ['qbdropcat', 'qbdropcat1'],
										handler: 'hidecatoptions',
									}"
								>
									<b-form-group class="qb-dd-group">
										<b-form-radio-group
											class="bct-checboxtext radio-drp-dwn"
											:options="expertiseoptions"
											v-model="$v.question.category.$model"
											@change="hidecatoptions"
											buttons
											stacked
										>
										</b-form-radio-group>
									</b-form-group>
								</div>
							</div>
							<div class="mt-2 relativeclass">
								<label class="bct-content-heading">Marks </label>
								<b-form-input
									class="bct-inputfield defaultCursor relativeclass"
									placeholder="Enter Marks"
									v-model="$v.question.marks.$model"
									:class="{
										error: $v.question.marks.$error,
									}"
								>
								</b-form-input>
								<div
									style="position: absolute; top: 38px; right: 15px"
									v-if="$v.question.marks.$dirty && !$v.question.marks.required"
									v-b-popover.hover.top.v-danger="{ content: 'Required' }"
									variant="primary"
								>
									<img src="../../assets/deletepopupicon.svg" alt="" />
								</div>

								<div
									style="position: absolute; top: 38px; right: 15px"
									v-else-if="
										!$v.question.marks.alpha && $v.question.marks.required
									"
									v-b-popover.hover.top.v-danger="{
										content: 'Enter a Valid Number between 0.5-100',
									}"
									variant="primary"
								>
									<img src="../../assets/deletepopupicon.svg" alt="" />
								</div>

								<div
									style="position: absolute; top: 38px; right: 15px"
									v-if="
										!$v.question.marks.between && $v.question.marks.required
									"
									v-b-popover.hover.top.v-danger="{
										content: 'Should be between (0.5, 100)',
									}"
									variant="primary"
								>
									<img src="../../assets/deletepopupicon.svg" alt="" />
								</div>
							</div>

							<div class="mt-2 position-relative relativeclass">
								<label class="bct-content-heading">Difficulty Level </label>
								<div
									ref="qbdropdiff1"
									@click="bctDrp2 = !bctDrp2"
									class="bct-select d-flex justify-content-between relativeclass"
									:class="{
										error: $v.question.difficultyLevel.$error,
									}"
								>
									<span class="text-truncate">{{
										question.difficultyLevel == "" ||
										question.difficultyLevel == null
											? "Select Difficulty"
											: "Difficulty level " + question.difficultyLevel
									}}</span>
									<span v-if="!bctDrp2"
										><img src="../../assets/carrotdown.svg" alt="" class="mr-1"
									/></span>
									<span v-else
										><img src="../../assets/uparrow.svg" alt="" class="mr-1"
									/></span>
									<div
										style="position: absolute; top: 8px; right: 28px"
										v-if="
											$v.question.difficultyLevel.$dirty &&
											!$v.question.difficultyLevel.required
										"
										v-b-popover.hover.top.v-danger="{ content: 'Required' }"
										variant="primary"
									>
										<img src="../../assets/deletepopupicon.svg" alt="" />
									</div>
								</div>

								<div
									v-if="bctDrp2"
									class="bct-checkboxcontainer pointer"
									ref="qbdropdiff"
									v-closable="{
										exclude: ['qbdropdiff', 'qbdropdiff1'],
										handler: 'hidediffoptions',
									}"
								>
									<b-form-group class="qb-dd-group">
										<b-form-radio-group
											class="bct-checboxtext radio-drp-dwn"
											:options="difficultoptions"
											v-model="$v.question.difficultyLevel.$model"
											name="radio-btn-stacked"
											buttons
											stacked
											@change="hidediffoptions"
										>
										</b-form-radio-group>
									</b-form-group>
								</div>
							</div>
						</div>
						<div style="width: 50%">
							<div class="position-relative">
								<label class="bct-content-heading">Add Tags</label>
								<div
									class="bct-inputfield defaultCursor relativeclass"
									ref="exp"
									v-closable="{
										exclude: ['exp', 'expdropdown'],
										handler: 'hidetagoptions',
									}"
								>
									<b-form-tags
										@input="addTags()"
										class="defaultCursor relativeclass"
										:class="
											$v.Tags.$error && question.questionTags.length == 0
												? 'error reqd_add_1'
												: 'reqd_add_2' && question.questionTags.length == 0
												? 'inputField'
												: 'tagsinputField'
										"
										:tag-validator="tagValidator"
										invalid-tag-text="Duplicate tag(s)"
										placeholder="Enter Question Tags"
										v-model="$v.Tags.$model"
										remove-on-delete
									></b-form-tags>
									<div
										style="position: absolute; right: 12px; top: 5px"
										v-if="
											$v.Tags.$dirty &&
											!$v.Tags.required &&
											question.questionTags.length == 0
										"
										v-b-popover.hover.top.v-danger="{ content: 'Required' }"
									>
										<img src="../../assets/deletepopupicon.svg" alt="" />
									</div>
								</div>
							</div>
							<div
								class="d-flex align-items-center flex-wrap mt-2 bct-tags-height"
							>
								<div
									class="bct-maincard-innertexts d-flex m-1"
									v-for="(i, index) in question.questionTags"
									:key="index"
								>
									<span> {{ i }}</span>
									<img
										@click="removeLocation(index)"
										class="ml-3 pointer"
										src="../../assets/greyCross.svg"
										alt=""
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-if="openTestCase" class="bct-main-content mt-2 mb-1">
				<div style="width: 100%" class="d-flex">
					<div class="position-relative" style="width: 49%">
						<div class="mt-2">
							<span class="bct-content-heading"> Input </span>

							<div class="mt-2">
								<b-form-textarea
									class="bct-testconfiginputField overflow-auto relativeclass"
									rows="4"
									max-rows="6"
									placeholder="Enter Input"
									type="text"
									v-model="$v.testcase.inputValue.$model"
									:class="{
										error:
											($v.testcase.inputValue.$error && !tcfieldempty) ||
											!$v.testcase.inputValue.maxLength,
									}"
								></b-form-textarea>
								<div
									style="position: absolute; top: 40px; right: 15px"
									v-if="
										$v.testcase.inputValue.$dirty &&
										!$v.testcase.inputValue.required &&
										!tcfieldempty
									"
									v-b-popover.hover.top.v-danger="{ content: 'Required' }"
									variant="primary"
								>
									<img src="../../assets/deletepopupicon.svg" alt="" />
								</div>
								<div
									style="position: absolute; top: 34px; right: 15px"
									v-if="
										!$v.testcase.inputValue.maxLength &&
										$v.testcase.inputValue.required
									"
									v-b-popover.hover.top.v-danger="{
										content: 'Should not exceed 1024 characters',
									}"
									variant="primary"
								>
									<img src="../../assets/deletepopupicon.svg" alt="" />
								</div>
							</div>
						</div>
						<div class="mt-2 relativeclass">
							<span class="bct-content-heading"> Output </span>

							<div class="mt-2">
								<b-form-textarea
									class="bct-testconfiginputField overflow-auto relativeclass"
									rows="4"
									max-rows="6"
									placeholder="Enter Expected Output"
									type="text"
									v-model="$v.testcase.outputValue.$model"
									:class="{
										error:
											($v.testcase.outputValue.$error && !tcfieldempty) ||
											!$v.testcase.outputValue.maxLength,
									}"
								></b-form-textarea>
								<div
									style="position: absolute; top: 34px; right: 15px"
									v-if="
										$v.testcase.outputValue.$dirty &&
										!$v.testcase.outputValue.required &&
										!tcfieldempty
									"
									v-b-popover.hover.top.v-danger="{ content: 'Required' }"
									variant="primary"
								>
									<img src="../../assets/deletepopupicon.svg" alt="" />
								</div>
								<div
									style="position: absolute; top: 34px; right: 15px"
									v-if="
										!$v.testcase.outputValue.maxLength &&
										$v.testcase.outputValue.required
									"
									v-b-popover.hover.top.v-danger="{
										content: 'Should not exceed 1024 characters',
									}"
									variant="primary"
								>
									<img src="../../assets/deletepopupicon.svg" alt="" />
								</div>
							</div>
						</div>
						<div class="d-flex align-items-center mt-4">
							<div>
								<b-form-checkbox
									class="checkbox"
									size="sm"
									name="checkbox-1"
									v-model="testcase.visible"
								>
									<div class="bct-nodataText">Visibility Test Case</div>
								</b-form-checkbox>
							</div>
						</div>
						<div
							class="d-flex align-items-center justify-content-between bct-button-pos w-100 pointer"
						>
							<div @click="openModal2()" class="bct-underlineText">
								<img
									class="mr-2"
									src="../../assets/uploadTestCase.svg"
									alt=""
								/>
								Upload test case template
							</div>

							<div v-if="!editcase">
								<b-button
									class="bct-save-btn d-flex align-items-center"
									@click="addtestcases"
								>
									<img class="mr-2" src="../../assets/whiteAddbtn.svg" alt="" />
									Add Test Case</b-button
								>
							</div>
							<div v-else>
								<b-button
									class="bct-save-btn d-flex align-items-center"
									@click="updatetestcase"
								>
									<img class="mr-2" src="../../assets/whiteAddbtn.svg" alt="" />
									Update Test Case</b-button
								>
							</div>
						</div>
					</div>
					<div class="bct-TC-left-box" style="width: 2%"></div>
					<div style="width: 49%">
						<div
							v-if="question.testCases && question.testCases.length == 0"
							class="d-flex align-items-center justify-content-center h-100"
						>
							<div>
								<img src="../../assets/addTestCase.svg" alt="" />
							</div>
						</div>
						<div v-else style="padding: 12px 0px 12px 22px">
							<div class="bct-testcase-head mb-2">Test Cases</div>
							<div class="bct-right-overflow">
								<div v-for="(tcase, k) in question.testCases" :key="k">
									<div v-if="index != k" class="bct-TC-card d-flex p-3 mt-3">
										<div style="width: 60%">
											<div>Test Case {{ k + 1 }}</div>
											<div class="d-flex mt-3">
												<div class="bct-card-subtext" style="width: 25%">
													Input
												</div>
												<div
													class="bct-card-subvalue"
													style="width: 75%; overflow-wrap: break-word"
												>
													{{ tcase.inputValue }}
												</div>
											</div>
											<div class="d-flex mt-3">
												<div class="bct-card-subtext" style="width: 25%">
													Output
												</div>
												<div
													class="bct-card-subvalue"
													style="width: 75%; overflow-wrap: break-word"
												>
													{{ tcase.outputValue }}
												</div>
											</div>
										</div>
										<div style="width: 40%">
											<div
												class="d-flex align-items-center justify-content-end p-3"
											>
												<img
													v-b-popover.hover.top="'Edit'"
													class="mr-4"
													src="../../assets/edit.svg"
													alt=""
													@click="edittestcase(k)"
												/>
												<img
													v-b-popover.hover.top="'Delete'"
													src="../../assets/greyBin (1).svg"
													alt=""
													@click="deletetestcase(k)"
												/>
											</div>
											<div class="bct-card-subtext bct-visibility-pos">
												visibility Test Case :<b
													>&nbsp;&nbsp;{{ tcase.visible }}</b
												>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div
				v-show="openCode"
				class="bct-main-snippet-content mb-1 p-2"
				ref="codeSnippetContainer"
			>
				<div class="bct-access-background">
					<div class="bct-snippet-head mb-3">Accepted Language</div>
					<div class="mb-3">
						<b-form-checkbox
							size="sm"
							v-model="languageAll"
							name="checkbox-1"
							@change="langselect"
						>
							<div class="bct-select-all">Select All</div>
						</b-form-checkbox>
					</div>
					<b-row class="p-1">
						<b-col cols="2" v-for="(option, i) in allLanguges" :key="i">
							<b-form-checkbox
								size="sm"
								:value="option.languageID"
								v-model="selectedLanguages"
								name="role-check-button"
							>
								<p>{{ option.languageName }}</p>
							</b-form-checkbox>
						</b-col>
					</b-row>
				</div>
				<div
					class="bct-main-content-2 mt-2 d-flex position-relative"
					:style="{
						height: showfullScreen ? 'calc(100vh - 180px)' : '',
					}"
				>
					<div
						style="width: 39%"
						class="bct-left-snippet"
						:style="{
							height: showfullScreen ? 'calc(100vh - 275px)' : '',
						}"
					>
						<div>
							<div class="mt-2">
								<label class="bct-content-heading">Function </label>
								<b-form-input
									class="bct-inputfield defaultCursor"
									placeholder="Enter Function Name"
									type="text"
									:class="{
										error: $v.selectedFunctionName.$error,
									}"
									v-model="$v.selectedFunctionName.$model"
								>
								</b-form-input>
								<div
									style="position: absolute; top: 65px; right: 63%"
									v-if="$v.selectedFunctionName.$error"
									v-b-popover.hover.top.v-danger="{
										content: 'Please enter the function name',
									}"
									variant="primary"
								>
									<img src="../../assets/deletepopupicon.svg" alt="" />
								</div>
								<div class="bct-cancel-btn-parent bct-generate-code-btn mt-4">
									<b-button @click="openModal()" class="bct-cancel-btn mr-4"
										>Generate Code</b-button
									>
								</div>
							</div>
						</div>
					</div>
					<div
						class="bct-TC-left-box"
						style="width: 2%"
						:style="{
							height: showfullScreen ? 'calc(100vh - 275px)' : '',
						}"
					></div>
					<div
						style="width: 59%"
						class="p-3"
						:style="{
							height: showfullScreen ? 'calc(100vh - 275px)' : '',
						}"
					>
						<div class="d-flex align-items-center mb-2 justify-content-between">
							<div class="bct-testcase-head">Body</div>
							<div
								class="d-flex justify-content-end"
								v-if="totaldataforalllangtemp.length > 0"
							>
								<img
									v-b-popover.hover.top="'Full Screen'"
									src="../../assets/fullscreen.svg"
									alt=""
									srcset=""
									@click="showInFullScreen()"
									style="margin-right: 20px"
								/>
								<div style="width: 270px" class="position-relative mr-2">
									<div
										@click="showtopiccard = !showtopiccard"
										class="cq-lang-container d-flex align-items-center justify-content-between"
									>
										<div class="cq-accept-lang">Accepted Language</div>
										<div class="cq-langline"></div>
										<div class="cq-lang-text">
											{{ topicCardselected }}
											<img
												class="ml-3"
												src="../../assets/downarrow.svg"
												alt=""
											/>
										</div>
									</div>
									<div v-if="showtopiccard" class="cq-selectLang-cont">
										<b-form-group
											class="cq-typeradio"
											v-for="(i, index) in totaldataforalllangtemp"
											:key="index"
										>
											<b-form-radio
												class="m-1"
												size="sm"
												v-model="topicCardselected"
												:value="i.languageName"
												@change="getTopicValue(i)"
											>
												{{ i.languageName }}
											</b-form-radio>
										</b-form-group>
									</div>
								</div>
							</div>
							<b-button
								class="tc-save-btn"
								@click="runCode"
								:disabled="isRunningCode"
							>
								<span v-if="isRunningCode">Running...</span>
								<span v-else>Run Code</span>
							</b-button>
						</div>
						<div
							class="editorContainer bct-code-body w-100"
							ref="editorContainer"
							id="editorContainer"
							:style="{
								height: showfullScreen ? 'calc(100vh - 345px)' : '',
							}"
						></div>
					</div>
				</div>
				<div
					v-if="showResult"
					class="bg-white"
					style="
						box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
						border-radius: 5px;
					"
				>
					<div class="tc-test-result mt-2 mb-4 mr-1 p-2">Test Result</div>
					<div class="tc-bottom-button m-1 mr-1 p-2">
						<div v-if="failedtestcase > 0">
							<div class="tc-redTop">
								Compilation Failed -
								{{ failedtestcase }}/{{ question.testCases.length }}
								test cases Failed
							</div>
							<div class="p-2">
								<span class="tc-preview-head"> Compile Message </span>
								<div class="tc-card-subtext mt-4">
									{{ compileMessage.stderr }}
								</div>
							</div>
						</div>
						<div class="tc-greenTop" v-else>
							Completed Successfully - All test cases are passed
						</div>
						<hr />
						<img class="ml-2" src="../../assets/nonView.svg" alt="" /><span
							class="tc-preview-head ml-2"
							>Invisible test Cases for candidate</span
						>
						<div class="p-2">
							<span class="tc-preview-head">Test Cases</span>
							<div class="d-flex mt-4">
								<div class="tc-many-trialCase-left" style="width: 25%">
									<div
										class="p-2 tc-many-testCase-text pointer"
										v-for="(data, i) in executionData"
										:class="
											showIcon == i
												? 'tc-many-testCase-sel-text pointer'
												: 'p-2 tc-many-testCase-text pointer'
										"
										:key="i"
										@click="hideIcon(i, data)"
									>
										<img
											v-if="data.testStatus == 'PASSED'"
											class="mr-1"
											src="../../assets/testCasePass.svg"
											alt=""
										/>
										<img
											v-else
											class="mr-1"
											src="../../assets/testCaseFail.svg"
											alt=""
										/>
										Test Case {{ i + 1 }}
										<img
											v-if="!data.visible"
											class="ml-2"
											src="../../assets/nonView.svg"
											alt=""
										/>
									</div>
								</div>
								<div class="tc-many-testCase-right" style="width: 75%">
									<div class="tc-TC-card p-3 m-2">
										<span class="tc-preview-head">Input</span>
										<div class="tc-card-subtext ml-3 mt-2">
											{{ showTestCaseData.inputValue }}
										</div>
									</div>
									<div class="tc-TC-card p-3 m-2">
										<span class="tc-preview-head">Expected Output</span>
										<div class="tc-card-subtext ml-3 mt-2">
											{{ showTestCaseData.outputValue }}
										</div>
									</div>
									<div class="tc-TC-card p-3 m-2">
										<span class="tc-preview-head">Your Output</span>
										<div class="tc-card-subtext ml-3 mt-2">
											{{ showTestCaseData.stdout || "null" }}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div
				class="bct-bottom-button d-flex align-items-center justify-content-end"
			>
				<div @click="goBack" class="bct-cancel-btn-parent">
					<b-button class="bct-cancel-btn mr-4">Cancel</b-button>
				</div>
				<b-button @click="updateQuestion()" class="bct-save-btn"
					>Update</b-button
				>
			</div>
		</template>
		<b-modal
			id="uploadTestCase"
			centered
			hide-footer
			hide-header
			@show="removeExcelFromPopUp"
			@hidden="removeExcelFromPopUp"
			class="qb-add-ques-modal"
			no-stacking
			no-close-on-backdrop
		>
			<div>
				<div>
					<div
						@click="$bvModal.hide('uploadTestCase'), removeExcelModal()"
						class="xMarkCancel"
					>
						<img src="../../assets/xmark.svg" alt="" />
					</div>
					<div class="modalheading">Upload Test Cases</div>
					<hr />
					<b-form-file
						@input="handleClick"
						v-model="excelFile"
						ref="excel-upload-input"
						class="mb-2"
						accept=".xlsx, .xls"
					></b-form-file>

					<div class="asterik mt-2" v-if="errorFile">
						Upload Failed!! Please upload supported format (.xls,.xlsx)
					</div>

					<div
						class="uploadfile-container p-2"
						v-if="excelFile != '' && errorFile == false"
					>
						<div class="d-flex justify-content-between align-items-center mt-1">
							<div class="modalheading">{{ excelFile.name }}</div>

							<div>
								<img
									src="../../assets/cross-round.svg"
									alt=""
									class="pointer"
									@click="removeExcelFile"
								/>
							</div>
						</div>
						<div class="mt-3 relativeclass">
							<div class="fieldsetstyle modalheading">
								Select Sheet <span class="asteri">*</span>
							</div>
							<div
								class="pointer section-content d-flex justify-content-between align-items-center"
								@click="showselecteddropdown = !showselecteddropdown"
							>
								<div class="sectionname">
									<div>
										<span
											class="sbox-subtext cj-noofrecoption"
											v-if="excelSheetNameShow != 0"
										>
											{{ excelSheetNameShow.length }} sheet(s) selected
										</span>

										<div v-else>Choose sheets</div>
									</div>
								</div>

								<div class="pointer" v-if="showselecteddropdown">
									<img src="../../assets/uparrow.svg" alt="" />
								</div>
								<div class="pointer" v-else>
									<img src="../../assets/downarrow.svg" alt="" />
								</div>
							</div>
						</div>
						<div class="dropdown-container" v-if="showselecteddropdown">
							<div class="relativeclass aoeinput">
								<template v-if="excelSheetName.length > 1">
									<div class="aoesearchicon-pos">
										<img src="../../assets/searchicon.svg" alt="" />
									</div>
									<b-form-input
										class="input-field"
										text="text"
										placeholder="Search"
										v-model="searchexcelsheets"
									>
									</b-form-input>
								</template>
								<div class="height-dropdown-container pr-1 mt-2">
									<b-form-group>
										<b-form-checkbox
											class="secdropdowncolor p-2 pointer"
											size="sm"
											v-model="excelSheetNameShow"
											v-for="option in excelSheetNamesearch"
											:key="option"
											:value="option"
											@change="searchexcelsheets = ''"
										>
											{{ option }}
										</b-form-checkbox>
									</b-form-group>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="mt-4 profile-details">
					<span class="asterik">*</span>
					<span
						>Click on Download Template to Fill the details of Test cases and
						Upload the File.</span
					>
				</div>

				<div class="mt-3 d-flex justify-content-between">
					<div>
						<b-button
							variant="outline"
							class="cursor-pointer p-2 ml-n2"
							@click="getTemplate()"
						>
							<span
								><img src="../../assets/downloadTestCase.svg" alt=""
							/></span>
							<span class="ml-2 qb-add-more-matches">Download Template</span>
						</b-button>
					</div>
					<div class="d-flex justify-content-between align-items-center">
						<div
							class="cancelbtntext pointer"
							@click="$bvModal.hide('uploadTestCase'), removeExcelFile()"
						>
							Cancel
						</div>
						<b-button
							:disabled="uploadDisable"
							class="addbtn ml-3 pr-3 pl-3"
							@click="uploadExcel"
							>Upload</b-button
						>
					</div>
				</div>
			</div>
		</b-modal>
		<!-- modal to confirm changes or exit  -->
		<b-modal
			id="confirm-undo"
			centered
			hide-footer
			hide-header
			class="qb-add-ques-modal"
		>
			<div class="modalheading">
				Caution !
				<img class="pr-3" src="../../assets/caution.svg" alt="" />
			</div>
			<div
				@click="$bvModal.hide('confirm-undo'), (discardchanges = false)"
				class="xMarkCancel"
			>
				<img src="../../assets/xmark.svg" alt="" />
			</div>
			<hr />
			<div class="mt-2 caution-modal-text">
				You have unsaved data. Click On 'OK' to save changes. Click On 'Cancel'
				to discard changes.
			</div>
			<div class="d-flex align-items-center justify-content-end mt-3">
				<b-button
					class="addbtn mr-2 pt-2 pb-2 pl-4 pr-4"
					@click="updateQuestion"
					>Ok</b-button
				>
				<b-button class="addbtn mr-2 pt-2 pb-2 pl-4 pr-4" @click="handlechange"
					>Cancel</b-button
				>
			</div>
		</b-modal>
	</div>
</template>

<script>
const XLSX = require("xlsx");
import QuillEditor from "../../components/forms/quillEditor.vue"; //Quill editor from component
import availableLanguages from "./codeSnip";
import {
	getcodingquestion,
	updatecodingquestion,
	getcodesnippet,
	getCodingLanguages,
	codecompileforeachcase,
	gettestcasetemplate,
	uploadExcel,
} from "../../utils/apiFunctions.js";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import { isExcel } from "../../utils/checkFileType";
import toastFunction from "../../views/mixin/toast";
import {
	required,
	maxLength,
	helpers,
	between,
} from "vuelidate/lib/validators";

export default {
	name: "EditCodingTest",
	mixins: [toastFunction],
	components: {
		Spinner,
		QuillEditor,
	},
	data() {
		return {
			showTestCaseData: {},
			showTestCaseDataforclick: false,
			compileMessage: {},
			executionData: [],
			showResult: false,
			//For Editor
			addques1: false,
			addques2: false,
			addques3: false,
			addques4: false,
			tcfieldempty: true,
			tempData: "",
			discardchanges: false,
			dirtyCheckQuestion: false,
			dirtyCheckSampleInput: false,
			dirtyCheckSampleOutput: false,
			totaldataforalllangtemp: [],
			dirtyCheckConstraints: false,
			currentLangId: null,
			currentbody: null,
			currentlang: null,
			editorInstance: null,
			editorvalue: "",
			LoaderStatus: false,
			unsupportedLanguages: [],
			topicCardselected: null,
			totaldataforalllang: [],
			codesnippetInvalid: false,
			codeSnippet: "//your code  is here",
			index: -1,
			visibletestcase: false,
			editcase: false,
			testcase: {
				inputValue: "",
				outputValue: "",
				visible: false,
			},
			showtopiccard: false,
			selectedFunctionName: null,
			allLanguges: [],
			languageAll: false,
			selectedLanguages: [],
			Tags: [],
			tag: "",
			expertise: "",
			difficultylevel: "",
			lastWindowSize: {
				width: window.innerWidth,
				height: window.innerHeight,
			},
			excelFile: "",
			excelSheetNameShow: [],
			excelSheetName: [],
			showselecteddropdown: false,
			searchexcelsheets: "",
			errorFile: false,
			question: {
				category: "",
				config: [],
				constraints: "",
				defaultBody: { CODELANG002: { head: "see", body: "no", tail: "true" } },
				question: "",
				marks: "",
				difficultyLevel: "",
				questionTags: [],
				sampleInput: "",
				sampleOutput: "",
				status: "",
				testCases: [],
				title: "",
			},
			bctDrp4: false,
			bctDrp3: false,
			bctDrp2: false,
			bctDrp1: false,
			loopVar: 20,
			loopVar2: 5,
			noTestCase: true,
			openQuestion: true,
			openPreview: false,
			openCode: false,
			openTestCase: false,
			questionInvalid: false,
			testInvalid: false,
			editorConfig: {
				toolbar: ["Bold", "Italic", "-", "NumberedList", "BulletedList", "-"],
			},
			differntprops: [],
			difficultoptions: [
				{ text: "Difficulty level 1", value: "1" },
				{ text: "Difficulty level 2", value: "2" },
				{ text: "Difficulty level 3", value: "3" },
				{ text: "Difficulty level 4", value: "4" },
				{ text: "Difficulty level 5", value: "5" },
			],

			returnoptions: [
				{ text: "Int", value: "java" },
				{ text: "Float", value: "sql" },
				{ text: "Double", value: "c++" },
				{ text: "Void", value: "c" },
			],

			expertiseoptions: [
				{ text: "Front End Developer", value: "Front End Developer" },
				{ text: "Back End Developer", value: "Back End Developer" },
				{ text: "Graphic designer", value: "Graphic Designer" },
				{ text: "Tester", value: "Tester" },
			],
			tagsoptions: [
				{ name: "Array", code: "Array" },
				{ name: "Binary Search", code: "Binary Search" },
				{ name: "Graphics designer", code: "Graphics designer" },
				{ name: "Maths", code: "Maths" },
				{ name: "Chemistry", code: "Chemistry" },
			],
			language_options: [
				{ text: "View_Topic", value: "GET_TOPIC" },
				{ text: "Add_Topic", value: "PUSH_TOPIC" },
				{ text: "Edit_Topic", value: "PUT_TOPIC" },
				{ text: "Delete_Topic", value: "DELETE_TOPIC" },
				{ text: "View_Test", value: "GET_TEST" },
				{ text: "Add_Test", value: "PUSH_TEST" },
				{ text: "Edit_Test", value: "PUT_TEST" },
				{ text: "Delete_Test", value: "DELETE_TEST" },
				{ text: "View_Question", value: "GET_QUESTION" },
				{ text: "Add_Question", value: "PUSH_QUESTION" },
				{ text: "Edit_Question", value: "PUT_QUESTION" },
				{ text: "Delete_Question", value: "DELETE_QUESTION" },
				{ text: "View_Individual", value: "GET_TEST_INDIVIDUAL" },
				{ text: "Add_Individual", value: "PUSH_TEST_INDIVIDUAL" },
				{ text: "Edit_Individual", value: "PUT_TEST_INDIVIDUAL" },
				{ text: "Delete_Individual", value: "DELETE_TEST_INDIVIDUAL" },
				{ text: "View_Group", value: "GET_TEST_GROUP" },
				{ text: "Add_Group", value: "PUSH_TEST_GROUP" },
			],
			showfullScreen: false,
			isRunningCode: false,
		};
	},
	validations: {
		selectedFunctionName: {
			required,
			maxLength: maxLength(20),
		},
		question: {
			title: {
				required,
				maxLength: maxLength(120),
			},
			question: {
				required,
				maxLength: maxLength(10000),
			},
			sampleInput: {
				required,
				maxLength: maxLength(1024),
			},
			sampleOutput: {
				required,
				maxLength: maxLength(1024),
			},
			constraints: {
				required,
				maxLength: maxLength(1024),
			},
			category: {
				required,
			},
			questionTags: {
				required,
			},
			marks: {
				required,
				alpha: helpers.regex("alpha", /^\d{1,3}\.?\d{0,2}$/),
				between: between(0.5, 100),
			},
			difficultyLevel: {
				required,
			},
		},
		Tags: {
			required,
		},
		testcase: {
			inputValue: {
				required,
				maxLength: maxLength(1024),
			},
			outputValue: {
				required,
				maxLength: maxLength(1024),
			},
		},
	},
	watch: {
		lastWindowSize() {
			if (this.editorInstance) {
				this.editorInstance.layout();
			}
		},
		//function to check select all for coding languages
		selectedLanguages() {
			if (this.selectedLanguages.length == this.allLanguges.length) {
				this.languageAll = true;
			} else {
				this.languageAll = false;
			}
			this.pushlanguages();
		},
		allLanguges() {
			if (this.selectedLanguages.length == this.allLanguges.length) {
				this.languageAll = true;
			} else {
				this.languageAll = false;
			}
		},
		editorvalue() {
			// Watch for changes in the local editorValue property
			// This will trigger whenever the editor content changes
			this.checkEditorValue();
		},
	},
	// checking if there have been any changes before exiting and routing elsewhere
	beforeRouteLeave(to, from, next) {
		if (
			this.tempData === JSON.stringify(this.question) ||
			this.discardchanges
		) {
			next();
		} else {
			let temptempdata = JSON.stringify(this.question);
			for (const key in this.tempData) {
				if (Object.hasOwn(this.tempData, key)) {
					// Compare the properties of obj1 and obj2
					if (this.tempData[key] !== temptempdata[key]) {
						console.log(this.tempData[key], "tempData");
						console.log(temptempdata[key], "temptempdata");
					}
				}
			}

			next(false);
			this.$bvModal.show("confirm-undo");
		}
	},
	async created() {
		this.LoaderStatus = true;
		if (this.$route.query.questionKey) {
			this.getQuestion(this.$route.query.questionKey);
		}
		this.getalllangs();
	},
	mounted() {
		document.addEventListener("fullscreenchange", () => {
			console.log("Fullscreen changed →", !!document.fullscreenElement);
		});
		window.addEventListener("resize", this.handleZoomChange);
		this.$refs.TitleInput.focus();
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.handleZoomChange);
	},
	computed: {
		uploadDisable() {
			return this.excelFile === "" && this.excelSheetNameShow.length === 0;
		},
		excelSheetNamesearch() {
			return this.excelSheetName.filter((data) => {
				return (
					!this.searchexcelsheets ||
					data.toLowerCase().includes(this.searchexcelsheets.toLowerCase())
				);
			});
		},
	},
	methods: {
		normalizeOutput(output) {
			return output?.trim().replace(/\r?\n/g, "").replace(/\s+/g, " ");
		},
		async runCode() {
			if (this.isRunningCode) return;

			this.isRunningCode = true;
			this.executionData = [];
			this.failedtestcase = 0;
			this.showResult = true;
			console.log(
				this.topicCardselected,
				availableLanguages,
				"availableLanguages"
			);
			const selected =
				this.topicCardselected === "c++" ? "cpp" : this.topicCardselected;

			let currentlanddetails = availableLanguages.filter(
				(data) => data.language === selected
			);

			const extractedCode = this.editorInstance.getValue();

			try {
				// 1️⃣ Create all API promises
				const apiCalls = this.question.testCases.map((data) => {
					let payload = {
						language: currentlanddetails[0].language,
						stdin: data.inputValue,
						files: [
							{
								name: currentlanddetails[0].properties.name,
								content: extractedCode,
							},
						],
					};

					return codecompileforeachcase(payload);
				});

				// 2️⃣ Call all APIs at once
				const responses = await Promise.all(apiCalls);

				// 3️⃣ Process responses
				responses.forEach((response, index) => {
					const result = response.data;
					this.compileMessage = result;
					const data = this.question.testCases[index];

					let testStatus = "PASSED";

					if (result.stderr || result.exception) {
						testStatus = "ERROR";
						this.failedtestcase++;
					} else {
						const actual = this.normalizeOutput(result.stdout);
						const expected = this.normalizeOutput(data.outputValue);

						if (actual !== expected) {
							testStatus = "FAILED";
							this.failedtestcase++;
						}
					}

					this.executionData.push({ ...result, ...data, testStatus });
					this.hideIcon(index, this.executionData[index]);

					if (response.status == 200) {
						this.showResult = true;
					}
					setTimeout(() => {
						const scrollContainer = this.$refs.scrollContainer;
						scrollContainer.scrollIntoView({
							behavior: "smooth",
							block: "end",
						});
					}, 200);
				});
			} catch (error) {
				console.error(error);
			} finally {
				this.isRunningCode = false; // re-enable after all test cases finish
			}
		},
		hideIcon(index, data) {
			this.showTestCaseDataforclick = true;
			this.showTestCaseData = data;
			this.showIcon = index;
		},
		makeDirtyFalse() {
			this.addques1 = true;
			this.addques2 = true;
			this.addques3 = true;
			this.addques4 = true;

			this.dirtyCheckQuestion = false;
			this.dirtyCheckSampleInput = false;
			this.dirtyCheckSampleOutput = false;
			this.dirtyCheckConstraints = false;
		},
		//For 1st editor
		validateText(val) {
			this.dirtyCheckQuestion = val;
		},
		updateQuestionContent(newContent) {
			this.question.question = newContent;
		},
		changedaddQues(newval) {
			this.addques1 = newval;
		},

		//For 2nd editor
		validateText2(val) {
			this.dirtyCheckSampleInput = val;
		},
		updateQuestionContent2(newContent) {
			this.question.sampleInput = newContent;
		},
		changedaddQues2(newval) {
			this.addques2 = newval;
		},

		//For 3rd Editor
		validateText3(val) {
			this.dirtyCheckSampleOutput = val;
		},
		updateQuestionContent3(newContent) {
			this.question.sampleOutput = newContent;
		},
		changedaddQues3(newval) {
			this.addques3 = newval;
		},

		//For 4th Editor
		validateText4(val) {
			this.dirtyCheckConstraints = val;
		},
		updateQuestionContent4(newContent) {
			this.question.constraints = newContent;
		},
		changedaddQues4(newval) {
			this.addques4 = newval;
		},

		getDesiredContent2(contentType) {
			const tempDiv = document.createElement("div");
			let contentToDisplay = "";

			switch (contentType) {
				case "question":
					contentToDisplay = this.question.question;
					break;
				case "sampleInput":
					contentToDisplay = this.question.sampleInput;
					break;
				case "sampleOutput":
					contentToDisplay = this.question.sampleOutput;
					break;
				case "constraints":
					contentToDisplay = this.question.constraints;
					break;
				default:
					break;
			}

			tempDiv.innerHTML = contentToDisplay;

			const pTags = Array.from(tempDiv.querySelectorAll("p"));

			const endIndex = pTags.findIndex((pTag) =>
				this.isBetweenContentTag(pTag)
			);

			pTags
				.filter((pTag, index) => index >= endIndex && !pTag.textContent.trim())
				.forEach((pTag) => pTag.remove());

			switch (contentType) {
				case "question":
					this.question.question = tempDiv.innerHTML;
					break;
				case "sampleInput":
					this.question.sampleInput = tempDiv.innerHTML;
					break;
				case "sampleOutput":
					this.question.sampleOutput = tempDiv.innerHTML;
					break;
				case "constraints":
					this.question.constraints = tempDiv.innerHTML;
					break;
				default:
					break;
			}
		},

		isBetweenContentTag(element) {
			return element.textContent.trim() !== "";
		},

		initializeEditor() {
			let snip = this.currentbody;
			const editorContainer = document.querySelector(".editorContainer");
			window.require.config({
				paths: {
					vs: "https://cdn.jsdelivr.net/npm/monaco-editor@latest/min/vs",
				},
			});
			window.require(["vs/editor/editor.main"], () => {
				this.editorInstance = window.monaco.editor.create(editorContainer, {
					value: snip,
					language: this.currentlang,
					theme: "vs-dark",
				});
			});
			const editorModel = this.editorInstance.getModel();

			// Attach an event listener to capture content changes
			editorModel.onDidChangeContent(() => {
				this.editorvalue = editorModel.getValue();
			});
		},
		getTopicValue(data) {
			this.currentLangId = data.id;
			this.currentbody = data.body;
			this.currentlang = data.language;
			this.activeForTopic = data;
			this.showtopiccard = false;
			this.removeEditor();
			this.initializeEditor();
		},
		async getalllangs() {
			try {
				const getAllQuestions = await getCodingLanguages();
				this.allLanguges = availableLanguages;
				if (getAllQuestions.status == 200) this.LoaderStatus = false;
			} catch (error) {
				this.errorToast(error.response.data.data.Data);
				throw new Error(`Failed! Status:${error.status}`);
			}
		},
		pushlanguages() {
			this.allLanguges.forEach((item) => {
				let obj = {
					body: "",
					languageName: "",
					id: "",
					extension: "",
					languageType: "",
					language: "",
					properties: {},
				};
				if (this.selectedLanguages.includes(item.languageID)) {
					const existingItem = this.totaldataforalllangtemp.find(
						(lang) => lang.id === item.languageID
					);
					if (!existingItem) {
						obj.body = item.properties.content;
						obj.languageName = item.languageName;
						obj.id = item.languageID;
						obj.extension = item.extension;
						obj.languageType = item.languageType;
						obj.language = item.language;
						obj.properties = item.properties;
						this.totaldataforalllangtemp.push(obj);
					}
				}
			});
			this.totaldataforalllangtemp = this.totaldataforalllangtemp.filter(
				(item) => {
					return this.selectedLanguages.includes(item.id);
				}
			);
			if (this.totaldataforalllangtemp.length > 0) {
				this.topicCardselected = this.totaldataforalllangtemp[0].languageName;
				this.getTopicValue(this.totaldataforalllangtemp[0]);
			}
			this.totaldataforalllangtemp.forEach((item) => {
				this.question.defaultBody[item.id] = {
					body: item.body,
					languageName: item.languageName,
					properties: item.properties,
				};
			});
		},
		checkEditorValue() {
			this.totaldataforalllangtemp.forEach((item) => {
				if (item.languageName === this.topicCardselected) {
					item.body = this.editorvalue;
					this.question.defaultBody[item.id] = {
						body: item.body,
						languageName: item.languageName,
						properties: item.properties,
					};
				}
			});
			// Perform any further operations with the editor value here
		},
		showInFullScreen() {
			this.showfullScreen = !this.showfullScreen;
			const element = document.querySelector(".bct-main-snippet-content");
			console.log("element", element);

			if (!element) {
				console.warn("Container not found");
				return;
			}

			if (document.fullscreenElement) {
				console.log("fullscreen method");

				if (document.exitFullscreen) {
					document.exitFullscreen();
				} else if (document.mozCancelFullScreen) {
					document.mozCancelFullScreen();
				} else if (document.webkitExitFullscreen) {
					document.webkitExitFullscreen();
				} else if (document.msExitFullscreen) {
					document.msExitFullscreen();
				}

				setTimeout(() => {
					element.style.width = "auto";
					element.style.height = "calc(100vh - 285px)";
					this.editorInstance?.layout();
				}, 100);
			} else {
				console.log("hiiiii");

				// Not in fullscreen → request it
				this.requestfullscreen(element);

				// Wait a little to ensure fullscreen is active before styling
				setTimeout(() => {
					element.style.width = "100vw";
					element.style.height = "100vh";
					this.editorInstance?.layout();
				}, 300); // Delay ensures fullscreen happens first
			}
		},
		requestfullscreen(element) {
			console.log(element, "request full screen");

			if (element.requestFullscreen) {
				element.requestFullscreen();
			} else if (element.mozRequestFullScreen) {
				// Firefox
				element.mozRequestFullScreen();
			} else if (element.webkitRequestFullscreen) {
				// Chrome, Safari, and Opera
				element.webkitRequestFullscreen();
			} else if (element.msRequestFullscreen) {
				// IE/Edge
				element.msRequestFullscreen();
			}
		},
		//function for select all functionality
		langselect() {
			if (this.languageAll) {
				this.selectedLanguages = this.allLanguges.map(
					(data) => data.languageID
				);
			} else {
				this.selectedLanguages = [];
				this.totaldataforalllangtemp = [];
			}
		},
		goBack() {
			if (this.$route.query.sectionID) {
				this.$router.push({
					name: "QPBuilder",
					params: {
						testName: this.$route.query.testName,
						testID: this.$route.query.testID,
						topicName: this.$route.query.topicName,
						topicID: this.$route.query.topicID,
					},
					query: {
						sectionID: this.$route.query.sectionID,
					},
				});
			} else this.$router.go(-1);
		},
		topicFunction() {
			this.showtopiccard = !this.showtopiccard;
			this.$forceUpdate();
		},
		async getTemplate() {
			const res = await gettestcasetemplate();
			if (res.status == 200) {
				this.LoaderStatus = false;
				window.open(res.data.data.downloadLink);
			}
		},

		goToDocumentUpload() {
			this.$router.push({
				name: "tryCode",
			});
		},
		removeLocation(index) {
			console.log(index, "index");
			this.question.questionTags.splice(index, 1);
		},
		tagValidator(tag) {
			let skills = this.question.questionTags.map((s) => s.toLowerCase());

			if (skills.includes(tag.toLowerCase())) return false;
			else {
				this.tag = tag;
				return true;
			}
		},
		removeExcelFile() {
			this.$bvModal.hide("modal-multi-excel");
			this.excelFile = "";
			this.excelSheetNameShow = [];
			this.excelSheetName = [];
			this.$forceUpdate();
		},
		removeExcelFromPopUp() {
			this.excelFile = "";
			this.excelSheetNameShow = [];
		},
		addTags() {
			if (this.tag.trim() != "") {
				this.question.questionTags.push(this.tag);
			}
			this.tag = "";
			this.Tags = [];
		},
		openQuestionFunc() {
			this.openQuestion = true;
			this.openCode = false;
			this.openTestCase = false;
			this.openPreview = false;
		},
		openCodeFunc() {
			this.openQuestion = false;
			this.openCode = true;
			this.openTestCase = false;
			this.openPreview = false;
			setTimeout(() => {
				this.removeEditor();
				this.initializeEditor();
			}, 100);
		},
		openTestCaseFunc() {
			this.openQuestion = false;
			this.openCode = false;
			this.openTestCase = true;
			this.openPreview = false;
		},
		openPreviewFunc() {
			this.openPreview = true;
			this.openQuestion = false;
			this.openCode = false;
			this.openTestCase = false;
		},
		async openModal() {
			if (this.selectedLanguages.length <= 0) {
				this.errorToast("Please select atleast one language");
			}
			this.$v.selectedFunctionName.$touch();
			if (
				!this.$v.selectedFunctionName.$invalid &&
				this.selectedLanguages.length > 0
			) {
				this.responsedata = [];
				let data = {
					// languages: ['CODELANG066'],
					languages: this.selectedLanguages,
					functionName: this.selectedFunctionName,
				};
				const response = await getcodesnippet(data);
				if (response.status == 200) {
					const arrayOfObjects = response.data.data.data;
					this.question.defaultBody = arrayOfObjects;
					let arrayFromData = Object.entries(arrayOfObjects).map(
						([key, value]) => ({ id: key, ...value })
					);
					this.totaldataforalllang = arrayFromData;
					this.topicCardselected = arrayFromData[0].languageName;
					this.totaldataforalllangtemp.forEach((item1) => {
						let correspondingObj = this.totaldataforalllang.find(
							(item2) => item2.id === item1.id
						);
						if (correspondingObj) {
							item1.body = correspondingObj.body;
						}
					});
					this.responsedata = arrayFromData[0].body;
					this.currentLangId = arrayFromData[0].id;
					this.currentbody = arrayFromData[0].body;
					this.currentlang = arrayFromData[0].languageName;
					this.removeEditor();
					this.initializeEditor();
				} else if (response.status == 206) {
					this.unsupportedLanguages = response.data.failedLanguages;
					this.$nextTick(() => {
						this.successToast("Something went wrong. Please try again.");
					});
				}
			}
		},
		removeEditor() {
			if (this.editorInstance) {
				this.editorInstance.dispose(); // Dispose the editor instance
				const editorContainer = document.querySelector(".editorContainer");
				while (editorContainer.firstChild) {
					editorContainer.firstChild.remove(); // Remove all child nodes from the editor container
				}
			}
		},
		updatetestcase() {
			this.$v.testcase.$touch();
			if (!this.$v.testcase.$invalid) {
				this.question.testCases[this.index].inputValue =
					this.testcase.inputValue;
				this.question.testCases[this.index].outputValue =
					this.testcase.outputValue;
				this.question.testCases[this.index].visible = this.testcase.visible;
				this.testcase.inputValue = "";
				this.testcase.outputValue = "";
				this.testcase.visible = false;
				this.editcase = false;
				this.index = -1;
				this.$nextTick(() => {
					this.successToast("Testcase updated successfully.");
					this.tcfieldempty = true;
				});
			} else {
				this.tcfieldempty = false;
			}
		},
		edittestcase(index) {
			this.testcase.inputValue = this.question.testCases[index].inputValue;
			this.testcase.outputValue = this.question.testCases[index].outputValue;
			this.testcase.visible = this.question.testCases[index].visible;
			this.editcase = true;
			this.index = index;
		},
		addtestcases() {
			this.$v.testcase.$touch();
			if (!this.$v.testcase.$invalid) {
				this.question.testCases.push({
					inputValue: this.testcase.inputValue,
					outputValue: this.testcase.outputValue,
					visible: this.testcase.visible,
				});
				this.testcase.inputValue = "";
				this.testcase.outputValue = "";
				this.testcase.visible = false;
				this.$v.testcase.$reset();
				this.noTestCase = false;
			} else {
				this.tcfieldempty = false;
				this.errorToast("Please add atleast one test case...");
			}
		},
		deletetestcase(index) {
			this.question.testCases.splice(index, 1);
		},
		handlechange() {
			this.discardchanges = true;
			this.goBack();
		},
		handleZoomChange() {
			this.lastWindowSize = {
				width: window.innerWidth,
				height: window.innerHeight,
			};
			// this.removeEditor();
		},
		deleteproperties() {
			const propertiesToDelete = [
				"active",
				"actualQuestion",
				"addToPublic",
				"addToDatabank",
				"createdAt",
				"createdBy",
				"licenseKey",
				"questionMedia",
				"questionMediaType",
				"updatedAt",
			];

			propertiesToDelete.forEach((property) => {
				delete this.question[property];
			});
		},
		async updateQuestion() {
			if (this.totaldataforalllangtemp.length > 0) {
				this.updatelangarray();
				this.cleaningarray();
				this.populatingarray();
				if (Object.keys(this.question.defaultBody).length > 1) {
					this.removedefaultkey();
				}
			} else {
				this.codesnippetInvalid = true;
			}
			this.discardchanges = true;
			try {
				this.quilleditorvalid();

				this.question.status = 2;
				if (this.selectedLanguages.length > 0) {
					setTimeout(() => {
						this.removeEditor();
						this.initializeEditor();
					}, 100);
				}
				this.$v.question.$touch();
				this.updatevalidqe();
				if (this.question.testCases.length == 0) {
					this.testInvalid = true;
					this.$v.testcase.$touch();

					this.errorToast("Please add atleast one test case...");
				} else {
					const hasVisibleTestCase = this.question.testCases.some(
						(obj) => obj.visible
					);

					if (!hasVisibleTestCase) {
						this.errorToast("There must be at least one Visible test case...");
						this.testInvalid = true;
					} else {
						this.testInvalid = false;
					}
				}
				if (this.codesnippetInvalid) {
					this.errorToast("Please enter all the details...");
				}
				if (
					!this.questionInvalid &&
					!this.testInvalid &&
					!this.codesnippetInvalid
				) {
					this.getDesiredContent2("question");
					this.getDesiredContent2("sampleInput");
					this.getDesiredContent2("sampleOutput");
					this.getDesiredContent2("constraints");
					this.updateandroute();
				}
			} catch (error) {
				this.errorToast(error.response.data.data.Data);
				throw new Error(`Failed! Status:${error.status}`);
			}
		},
		updatevalidqe() {
			if (
				this.$v.question.$invalid ||
				this.dirtyCheckQuestion ||
				this.dirtyCheckSampleInput ||
				this.dirtyCheckSampleOutput ||
				this.dirtyCheckConstraints
			) {
				if (this.question.questionTags.length == 0) {
					this.$v.Tags.$touch();
				}
				this.questionInvalid = true;
				this.errorToast("Please enter all the details...");
			} else {
				this.questionInvalid = false;
			}
		},
		updatelangarray() {
			this.totaldataforalllangtemp.forEach((item) => {
				if (item.body === "") {
					console.log(item, "item");
					this.question.defaultBody[item.id] = {
						body: item.body,
						languageName: item.languageName,
						properties: item.properties,
					};
				}
			});
		},
		async updateandroute() {
			const res = await updatecodingquestion(this.question);
			if (res.status == 200) {
				this.$nextTick(() => {
					setTimeout(() => {
						this.successToast("Question edited successfully.");
					}, 200);
				});

				if (this.$route.query.sectionID) {
					this.$router.push({
						name: "QPBuilder",
						params: {
							testName: this.$route.query.testName,
							testID: this.$route.query.testID,
							topicName: this.$route.query.topicName,
							topicID: this.$route.query.topicID,
						},
						query: {
							sectionID: this.$route.query.sectionID,
						},
					});
				} else {
					this.$router.push({
						name: "tryCode",
						query: {
							questionKey: this.$route.query.questionKey,
							status: 3,
						},
					});
				}
				this.makeDirtyFalse();
			} else if (res.status == 409) {
				this.errorToast("Failed");
			}
		},
		quilleditorvalid() {
			if (this.question.question == "") {
				this.dirtyCheckQuestion = true;
			}
			if (this.question.sampleInput == "") {
				this.dirtyCheckSampleInput = true;
			}
			if (this.question.sampleOutput == "") {
				this.dirtyCheckSampleOutput = true;
			}
			if (this.question.constraints == "") {
				this.dirtyCheckConstraints = true;
			}
		},
		cleaningarray() {
			Object.keys(this.question.defaultBody).forEach((key) => {
				if (key == "undefined" || key == "body") {
					delete this.question.defaultBody[key];
				}
				if (!this.selectedLanguages.includes(key)) {
					delete this.question.defaultBody[key];
				}
			});
		},
		populatingarray() {
			this.totaldataforalllangtemp.forEach((item) => {
				this.question.defaultBody[item.id] = {
					body: item.body,
					languageName: item.languageName,
					properties: {
						name: item.properties.name,
						content: item.body,
					},
				};
			});
		},
		removedefaultkey() {
			this.question.defaultBody = Object.fromEntries(
				Object.entries(this.question.defaultBody).filter(
					([key, value]) =>
						!(
							key == "CODELANG002" &&
							value.head == "see" &&
							value.body == "no" &&
							value.tail == "true"
						)
				)
			);
		},
		async getQuestion(key) {
			const res = await getcodingquestion(key);
			let arrayFromData = Object.entries(res.data.data.defaultBody).map(
				([key, value]) => ({ id: key, ...value })
			);
			this.selectedLanguages = arrayFromData.map((data) => data.id);
			this.totaldataforalllang = arrayFromData;
			this.totaldataforalllangtemp = this.totaldataforalllang;

			this.topicCardselected = this.totaldataforalllang[0].languageName;
			this.codeSnippet = arrayFromData[0].body;
			this.LoaderStatus = false;
			this.currentLangId = arrayFromData[0].id;
			this.currentbody = arrayFromData[0].body;
			this.currentlang = arrayFromData[0].languageName;
			this.question = res.data.data;
			if (this.question.question === null) {
				this.question.question = "";
			}
			if (this.question.sampleInput === null) {
				this.question.sampleInput = "";
			}
			if (this.question.sampleOutput === null) {
				this.question.sampleOutput = "";
			}
			if (this.question.constraints === null) {
				this.question.constraints = "";
			}
			this.deleteproperties();
			this.tempData = JSON.stringify(this.question);
		},
		openModal2() {
			this.$bvModal.show("uploadTestCase");
		},
		async uploadExcel() {
			try {
				this.LoaderStatus = true;
				let form = new FormData();
				form.append("excel", this.excelFile);
				form.append("sheetName", JSON.stringify(this.excelSheetNameShow));

				// this.$route.params.jobID
				const res = await uploadExcel(form);
				this.showselecteddropdown = false;
				if (res.status == 200) {
					if (res.data.data.passedQuestion.length == 0) {
						this.$nextTick(() => {
							this.errorToast("Invalid template uploaded!");
						});
					} else {
						this.$nextTick(() => {
							this.successToast("Uploaded template successfully!");
						});
					}

					this.question.testCases = this.question.testCases.concat(
						res.data.data.passedQuestion
					);
					this.$bvModal.hide("uploadTestCase");
					this.LoaderStatus = false;
				} else if (res.status == 406) {
					this.$nextTick(() => {
						this.errorToast("Invalid template uploaded!");
					});
				}
			} catch (error) {
				this.LoaderStatus = false;
			}
		},
		removeExcelModal() {
			this.excelFile = "";
			this.excelSheetNameShow = [];
			this.excelSheetName = [];
			this.showselecteddropdown = false;
			this.$forceUpdate();
		},
		handleClick: function (event) {
			this.excelSheetNameShow = [];
			this.errorFile = false;
			let parts = event.name.split(".");

			let ext = parts[parts.length - 1];
			if (isExcel(ext)) {
				if (this.excelFile) {
					const reader = new FileReader();
					reader.onload = (e) => {
						// parse data
						const bstr = e.target.result;
						const wb = XLSX.read(bstr, { type: "binary" });
						this.excelSheetName = wb.SheetNames;
						if (this.excelSheetName.length == 1) {
							this.excelSheetNameShow.push(this.excelSheetName[0]);
						}
					};
					reader.readAsBinaryString(this.excelFile);
				}
			} else {
				this.errorFile = true;
			}
		},
		handleUpload() {
			this.$refs["excel-upload-input"].click();
		},
		hidediffoptions() {
			this.bctDrp2 = false;
		},
		hidecatoptions() {
			this.bctDrp1 = false;
		},
	},
};
</script>
<style>
.cq-lang-container {
	background: #fcfcfc;
	border: 1px solid #72738e;
	border-radius: 3px;
	padding: 5px 15px;
}
.cq-selectLang-cont {
	position: absolute;
	border-radius: 5px;
	border: 0.7px solid rgba(114, 115, 142, 0.5);
	background: #fff;
	box-shadow: 0px 4px 14px 0px rgba(0, 0, 0, 0.12);
	z-index: 1000;
	width: 100%;
	height: fit-content;
	max-height: 163px;
	overflow: auto;
}

.cq-langline {
	border: 1px solid #c4c4c4;
	width: 0px;
	height: 12px;
}

.cq-accept-lang {
	font-weight: 400;
	font-size: 12px;
	color: #464667;
}

.cq-lang-text {
	font-weight: 500;
	font-size: 12px;
	color: #464667;
}

.cq-typeradio:nth-child(odd) {
	background: #f4f4f4;
}

.cq-typeradio:nth-child(even) {
	background: #fdfdfd;
}

.cq-selectLang-cont .form-group {
	margin-bottom: 0px;
}
.editorshowInFullScreen {
	display: flex;
	align-items: center;
	justify-content: space-evenly;
}

.bct-yellow-position {
	position: absolute;
	left: 22px;
	z-index: 1;
}

.bct-main-head {
	font-weight: 600;
	font-size: 18px;
	color: #464667;
}

.bct-grey-btn {
	background: #ffffff;
	border: 1px solid #efefef;
	border-radius: 3px;
	font-weight: 500;
	font-size: 12px;
	color: #696969;
	padding: 5px 15px;
}

.bct-blue-btn {
	background: #ffffff;
	border: 1px solid #96c1dd;
	box-shadow: 0px 4px 6px rgba(196, 196, 196, 0.13);
	border-radius: 3px;
	font-weight: 600;
	font-size: 14px;
	color: #71aace;
	padding: 5px 15px;
}

.bct-ques {
	position: absolute;
	left: 250px;
	top: 15px;
}

.bct-testCase {
	position: absolute;
	top: 15px;
}

.bct-codeSnip {
	position: absolute;
	top: 15px;
	right: 246px;
}

.bct-main-content {
	background: #ffffff;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
	height: calc(100vh - 285px);
	padding: 20px;
	overflow: auto;
}

.bct-main-content-2 {
	background: #ffffff;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
	height: calc(100vh - 285px);
	padding: 20px;
}

.bct-main-snippet-content {
	height: calc(100vh - 285px);
	overflow: auto;
}

.bct-button-container {
	background: rgba(34, 85, 85, 0.065);
	border-radius: 8px;
	padding: 35px;
}

.bct-bottom-button {
	background: #ffffff;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
	padding: 15px;
}

.bct-cancel-btn {
	background: #fcfcfc;
	border: 1px solid #72738e;
	border-radius: 3px;
	font-weight: 500;
	font-size: 13px;
	color: #72738e;
	padding: 5px 15px;
}

.bct-save-btn {
	background: #72738e;
	border-radius: 3px;
	font-weight: 500;
	font-size: 13px;
	color: #ffffff;
	padding: 5px 15px;
}

.BuildCodingTest-main-container .bct-cancel-btn-parent .btn-secondary:focus,
.btn-secondary.focus {
	background: #fcfcfc;
	border: 1px solid #72738e;
	border-radius: 3px;
	font-weight: 500;
	font-size: 13px;
	color: #72738e;
	padding: 5px 15px;
}

.BuildCodingTest-main-container .bct-cancel-btn-parent .btn-secondary:hover {
	background: #fcfcfc;
	border: 1px solid #72738e;
	border-radius: 3px;
	font-weight: 500;
	font-size: 13px;
	color: #72738e;
	padding: 5px 15px;
}

.bct .bct-cancel-btn-parent .btn-secondary:focus,
.btn-secondary.focus {
	background: #fcfcfc;
	border: 1px solid #72738e;
	border-radius: 3px;
	font-weight: 500;
	font-size: 13px;
	color: #72738e;
	padding: 5px 15px;
}

.bct .bct-cancel-btn-parent .btn-secondary:hover {
	background: #fcfcfc;
	border: 1px solid #72738e;
	border-radius: 3px;
	font-weight: 500;
	font-size: 13px;
	color: #72738e;
	padding: 5px 15px;
}

.bct-select:focus {
	border: 0.7px solid rgba(10, 86, 200, 0.5);
}

.bct-select:hover {
	border: 0.7px solid rgba(10, 86, 200, 0.5);
}

.bct-select:active {
	border: 0.7px solid rgba(10, 86, 200, 0.5);
}

.bct-select {
	background: #fdfdfd;
	border: 0.7px solid rgba(10, 86, 200, 0.5);
	box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.25);
	border-radius: 3px;
	color: #6d6d6d;
	font-size: var(--size-13);
	padding: 8px;
}

.bct-od-ev:nth-child(odd) {
	background: #f4f4f4;
}

.bct-od-ev:nth-child(even) {
	background: #fdfdfd;
}

.bct-checkboxcontainer {
	background: #ffffff;
	border: 0.2px solid #8a8b8c;
	box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
	border-radius: 5px;
	min-height: auto;
	overflow-y: auto;
	width: 100%;
	position: absolute;
	z-index: 3;
}

.bct-checboxtext {
	font-weight: 400;
	font-size: 14px;
	color: #545454;
}

.cke_bottom {
	display: none !important;
}

.cke_chrome {
	display: block;
	background: #fdfdfd;
	border: 0.7px solid rgba(10, 86, 200, 0.5) !important;
	box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.25) !important;
	border-radius: 3px !important;
	padding: 0;
}

.bct-ck1 .cke_inner {
	display: block;
	background: #fdfdfd !important;
	height: 180px !important;
	padding: 0;
	-webkit-touch-callout: none;
	border-radius: 5px !important;
}

.bct-ck2 .cke_inner {
	display: block;
	background: #fdfdfd !important;
	height: 145px !important;
	padding: 0;
	-webkit-touch-callout: none;
	border-radius: 5px !important;
}

.bct-ck3 .cke_inner {
	display: block;
	background: #fdfdfd !important;
	height: 190px !important;
	padding: 0;
	-webkit-touch-callout: none;
	border-radius: 5px !important;
}

.bct-ck1 .cke_contents {
	display: block;
	height: 115px !important;
	overflow: hidden;
}

.bct-ck2 .cke_contents {
	display: block;
	height: 85px !important;
	overflow: hidden;
}

.bct-ck3 .cke_contents {
	display: block;
	height: 125px !important;
	overflow: hidden;
}

.cke_top {
	border-bottom: 1px solid #ececec !important;
	background: #f8f8f8;
	padding: 6px 8px 2px;
	white-space: normal;
	border-radius: 3px !important;
}

.cke_wysiwyg_frame,
.cke_wysiwyg_div {
	background-color: #fff;
	border-radius: 3px !important;
}

.cke_reset {
	margin: 0;
	padding: 0;
	border: 0;
	background: transparent;
	text-decoration: none;
	width: auto;
	height: auto;
	vertical-align: baseline;
	box-sizing: content-box;
	position: static;
	transition: none;
}

.bct-ques-left-container {
	border-right: 0.5px solid #adaaaa;
	padding: 25px 40px 25px 25px;
	overflow: auto;
}

.bct-ques-right-container {
	padding: 25px 40px 25px 25px;
	overflow: auto;
}

.bct-content-heading {
	font-weight: 500;
	font-size: 14px;
	color: #72738e;
}

.BuildCodingTest-main-container {
	border: 0.7px solid rgba(10, 86, 200, 0.5) !important;
	padding: 90px 20px 0px 80px;
}

.bct-inputfield {
	background: #fdfdfd;
	border: 0.7px solid rgba(10, 86, 200, 0.5);
	box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.25);
	border-radius: 3px;
	color: #6d6d6d;
	padding-right: 24px;
}

.bct-tagbox {
	min-height: auto;
	max-height: 110px;
	overflow: auto;
	background: #fdfdfd;
	border: 0.7px solid rgba(10, 86, 200, 0.5);
	box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.25);
	border-radius: 3px;
}

.b-form-tags input::placeholder {
	color: #6d6d6d !important;
	opacity: unset;
}

.bct-nodataText {
	font-weight: 500;
	font-size: 14px;
	color: #696969;
}

.bct-testconfiginputField {
	background: #fdfdfd;
	border: 0.7px solid rgba(10, 86, 200, 0.5);
	box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.25);
	border-radius: 3px;
	color: #72737e;
	padding: 1rem 1.75rem;
	max-height: 110px;
}

.bct-testcase-box {
	background: #ffffff;
	box-shadow: 0px 1px 8px rgba(196, 196, 196, 0.25);
	border-radius: 5px;
}

.bct-maincard-innertexts {
	background: #e6e6e6;
	border-radius: 14px;
	padding: 5px 10px;
	font-weight: 500;
	font-size: 12px;
	color: #72738e;
}

.bct-tags-height {
	overflow: auto;
}

.bct-TC-left-box {
	border-right: 0.5px solid #adaaaa;
	height: calc(100vh - 330px);
}

.bct-testcase-head {
	font-weight: 500;
	font-size: 14px;
	color: #333333;
}

.bct-right-overflow {
	overflow: auto;
	height: calc(100vh - 386px);
	padding: 0px 6px;
}

.bct-TC-selected-card {
	background: #f8f8f8;
	border: 1px solid #159cff;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
	position: relative;
}

.bct-TC-card {
	background: #ffffff;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
	position: relative;
}

.bct-card-subtext {
	font-weight: 400;
	font-size: 13px;
	color: #696969;
}

.bct-card-subvalue {
	font-weight: 400;
	font-size: 13px;
	color: #333333;
}

.bct-visibility-pos {
	position: absolute;
	right: 15px;
	bottom: 14px;
}

.bct-access-background {
	padding: 15px;
	flex-wrap: wrap;
	background: #ffffff;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
}

.bct-access-background p {
	font-weight: 400;
	font-size: 14px;
	color: #545454;
	white-space: nowrap;
	width: 150px;
	text-overflow: ellipsis;
	overflow: hidden;
}

.bct-access-background .custom-checkbox .custom-control-label::before {
	border-radius: 3px !important;
}

.bct-snippet-head {
	font-weight: 500;
	font-size: 14px;
	color: #464667;
}

.bct-select-all {
	font-weight: 400;
	font-size: 14px;
	color: #545454;
}

.bct-left-snippet {
	overflow: auto;
	height: calc(100vh - 365px);
	padding: 0px 11px 0px 0px;
}

.bct-generate-code-btn {
	bottom: 14px;
}

.bct-code-body {
	background: #3c3c3c;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
	overflow: hidden;
	height: calc(100vh - 400px) !important;
	color: #ffffff;
	font-size: 14px;
}

.bct-code-body-preview {
	background: #3c3c3c;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
	overflow: auto;
	height: calc(100vh - 246px);
	color: #ffffff;
	font-size: 14px;
}

.bct-modalheading {
	font-weight: 500;
	font-size: 16px;
	color: #333333;
}

.bct-modal-grey-back {
	background: #efefef;
	border-radius: 5px;
	font-weight: 400;
	font-size: 14px;
	color: #333333;
	overflow: auto;
	min-height: auto;
	max-height: calc(100vh - 355px);
}

.bct-modal-text {
	font-weight: 400;
	font-size: 14px;
	color: #333333;
}

.bct-upModal-grey-back {
	background: #f1f1f1;
	border-radius: 5px;
	padding: 15px;
	font-weight: 400;
	font-size: 14px;
	color: #565656;
}

.bct-preview-container {
	background: #ffffff;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
	height: calc(100vh - 205px);
	padding: 20px;
}

.bct-preview-line-box {
	border-right: 0.5px solid #adaaaa;
	height: calc(100vh - 245px);
}

.bct-preview-left {
	overflow: auto;
}

.bct-preview-head {
	font-size: 13px;
	font-weight: 500;
	color: #333333;
}

.bct-many-testCase-left {
	min-height: auto;
	max-height: calc(100vh - 635px);
	overflow: auto;
	background: #fbfafa;
	border-radius: 5px;
}

.bct-many-testCase-text {
	font-size: 12px;
	font-weight: 500;
	color: #696969;
}

.bct-many-testCase-right {
	min-height: auto;
	max-height: calc(100vh - 635px);
	overflow: auto;
}

.bct-many-testCase-sel-text {
	font-weight: 600;
	font-size: 14px;
	color: #3379b3;
	background: #eef2f5;
	border-radius: 5px 5px 0px 0px;
}

.bct-add-drop > .btn-secondary:nth-child(2n) {
	background: #fdfdfd;
	color: #545454;
	text-align: left;
	border: none;
}

.bct-add-drop > .btn-secondary:nth-child(2n-1) {
	background: #f4f4f4;
	color: #545454;
	text-align: left;
	border: none;
}

.bct-add-drop > .btn-secondary:not(:disabled):not(.disabled):active {
	color: var(--bg-white);
	background-color: var(--bg-tertiary);
	border-color: none;
}

.bct-add-drop .btn-secondary:not(:disabled):not(.disabled):active,
.bct-add-drop .btn-secondary:not(:disabled):not(.disabled).active,
.bct-add-drop .show > .btn-secondary.dropdown-toggle {
	color: var(--bg-white) !important;
	background-color: var(--bg-tertiary) !important;
	border-color: none;
	font-size: 15px !important;
	padding: 7px 13px !important;
}

.error {
	border: 1px solid red !important;
	border-radius: 4px;
}
.qb-dd-group .btn {
	text-align: left;
}
.ad-eval-validationicon {
	position: absolute;
	top: 5px;
	right: 12px;
	background: var(--bg-white);
}

.bct-underlineText {
	font-weight: 500;
	font-size: 14px;
	text-decoration-line: underline;
	color: #72738e;
}

.bct-button-pos {
	position: absolute;
	bottom: 0px;
}

.bct-modal-head {
	font-weight: 400;
	font-size: 13px;
	color: #545454;
}

.bct-info-text {
	font-weight: 400;
	font-size: 12px;
	color: #72738e;
}

.cdl-dot-main-d {
	text-align: center;
	margin: 20px 2px 20px 2px;
	padding-top: 20px;
	background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='13' ry='13' stroke='%2372738EFF' stroke-width='4' stroke-dasharray='6%2c 14' stroke-dashoffset='18' stroke-linecap='square'/%3e%3c/svg%3e");
	border-radius: 13px;
	word-wrap: break-word;
	height: 90px;
}

.bct-uploadFile-txt {
	font-weight: 500;
	font-size: 16px;
	color: #72738e;
}

.bct-afterUpload-grey {
	padding: 15px;
	background: #f1f1f1;
	border-radius: 5px;
	font-weight: 600;
	font-size: 14px;
	color: #565656;
}

.bct-afterUpload-red {
	padding: 15px;

	background: rgba(255, 71, 82, 0.15);
	border-radius: 5px;
	font-weight: 500;
	font-size: 14px;
	color: #ff4752;
}

.sorttext {
	font-family: "Poppins", sans-serif;
	font-style: normal;
	font-weight: 400;
	font-size: 12px;
}
.sortline {
	width: 0px;
	height: 19px;
	border: 1px solid #c4c4c4;
	background: #c4c4c4;
}
.tnt-sortcardcode {
	background: var(--bg-white);
	box-sizing: border-box;
	box-shadow: 0px 1px 4px rgb(0 0 0 / 25%);
	border-radius: 5px;
	top: 12px;
	right: 10px;
	padding: 5px 15px;
	position: absolute;
	z-index: 7;
	width: 250px;
	font-weight: 600;
	font-size: var(--size-13);
	color: #545454;
}
.jdtyperadio:nth-child(odd) {
	background: #f4f4f4;
}

.jdtyperadio:nth-child(even) {
	background: #fdfdfd;
}
.jdtypecardcode {
	width: 100%;
	top: 33px;
	right: 0;
}
.top-downarrowAlgn {
	margin-bottom: 2px;
}

.sortordertext {
	font-family: "Poppins", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 12px;
}
.radio-drp-dwn .btn-secondary {
	background-color: #fcfcfc;
	border: none;
	font-size: 14px;
	color: #696969;
}
.cancelbtntext {
	font-size: var(--size-13);
	font-weight: var(--weight-LM);
	color: var(--bg-tertiary);
}
.custom-file {
	font-size: 13px;
	color: #696969;
}
.tc-TC-card {
	background: #ffffff;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
	position: relative;
}

.tc-card-subtext {
	font-weight: 400;
	font-size: 13px;
	color: #696969;
}

.tc-code-body-preview {
	background: #3c3c3c;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
	overflow: auto;
	height: calc(100vh - 335px);
	color: #ffffff;
	font-size: 14px;
}

.tc-preview-container {
	background: #ffffff;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
	height: calc(100vh - 205px);
	padding: 20px;
}

.tc-preview-line-box {
	border-right: 0.5px solid #adaaaa;
	height: calc(100vh - 245px);
}

.tc-preview-left {
	overflow: auto;
}

.tc-preview-head {
	font-size: 13px;
	font-weight: 500;
	color: #333333;
}

.tc-many-testCase-left {
	min-height: auto;
	max-height: calc(100vh - 635px);
	overflow: auto;
	background: #fbfafa;
	border-radius: 5px;
}

.tc-many-testCase-text {
	font-size: 12px;
	font-weight: 500;
	color: #696969;
}

.tc-many-testCase-right {
	min-height: auto;
	max-height: calc(100vh - 580px);
	overflow: auto;
}

.tc-many-testCase-sel-text {
	font-weight: 600;
	font-size: 14px;
	color: #3379b3;
	background: #eef2f5;
	border-radius: 5px 5px 0px 0px;
}

.tc-many-trialCase-sel-text {
	background: #eef2f5;
}

.tc-many-trialCase-left {
	min-height: auto;
	max-height: calc(100vh - 600px);
	overflow: auto;
	background: #ffffff;
	border: 1px solid rgba(196, 196, 196, 0.25);
	border-radius: 3px;
}

.tc-test-result {
	font-weight: 500;
	font-size: 16px;
	color: #333333;
}

.tc-greenTop {
	background: #1cb803;
	box-shadow: 0px 1px 8px rgba(196, 196, 196, 0.25);
	border-radius: 5px 5px 0px 0px;
	font-weight: 500;
	font-size: 13px;
	color: #ffffff;
	padding: 5px 15px;
}

.tc-redTop {
	background: #f15c6a;
	box-shadow: 0px 1px 8px rgba(196, 196, 196, 0.25);
	border-radius: 5px 5px 0px 0px;
	font-weight: 500;
	font-size: 13px;
	color: #ffffff;
	padding: 5px 15px;
}

.tc-greenText {
	font-weight: 500;
	font-size: 12px;
	color: #1cb803;
}
</style>
